import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { useSectionParams } from '@/_i18n/section-params'
import { nextLinkHrefFromPathWithOptionalHash } from '@/_lib/next-link-href'
import { handleProgramaticScroll } from '@/_lib/utils'
import { SECTION_THEME_ENUM } from '@/_types/base'

export interface IAnnualProgram {
	id: number
	name: string
	nameShort?: string
	slug: string
	sectionTheme: SECTION_THEME_ENUM
	image?: {
		url: string
	}
}

interface IAAPCategoryCardProps {
	program: IAnnualProgram
}

const AAPCategoryCard: React.FC<IAAPCategoryCardProps> = ({ program }) => {
	const { getSectionParams } = useSectionParams('annualPrograms')
	const categoryHubLinkHref = nextLinkHrefFromPathWithOptionalHash(
		`/rocne-programy#${getSectionParams('annualProgramCategory')}-${program.slug}`
	)

	return (
		<article
			className={clsx(
				'item_action',
				'aspect-square w-full h-full flex flex-col relative',
				program.sectionTheme && `item_action_${program.sectionTheme}`
			)}
			style={{ overflow: 'visible' }}
		>
			<div className='item_action_inner flex flex-col h-full rounded-[22px] overflow-hidden'>
				<Link
					href={categoryHubLinkHref}
					title={program.name}
					className='item_action_image h-full block'
					prefetch={false}
					onClick={handleProgramaticScroll}
				>
					<Image
						src={program.image?.url || '/assets/layout/default-program.webp'}
						alt={`Medante - ${program.name}`}
						fill
						sizes='100%'
						priority
						quality={100}
						className='object-cover'
						unoptimized={true}
					/>
				</Link>
				<Link
					href={categoryHubLinkHref}
					title={program.name}
					className={`item_action_bottom cursornodrag flex justify-between items-center py-2.5! min-h-0!`}
					prefetch={false}
					onClick={handleProgramaticScroll}
				>
					<h4 className='item_action_title whitespace-nowrap'>
						<span className='hidden lg:block'>{program.name}</span>
						<span className='block lg:hidden'>{program.nameShort ?? program.name}</span>
					</h4>
					<svg className='sico'>
						<use href='/assets/layout/icons.svg#s_ar2_r' />
					</svg>
				</Link>
			</div>

			{program.slug === 'rodina' && (
				<div className='absolute -top-3 lg:-top-5 -right-4 lg:-top-5 lg:-right-5 h-14 w-14 lg:w-18 lg:h-18 bg-[rgb(163,65,164)] flex justify-center items-center text-center z-10 rounded-full'>
					<span className='text-white text-sm'>
						10%
						<br />
						zľava
					</span>
				</div>
			)}
		</article>
	)
}

export default AAPCategoryCard
